const BLOCK_LIKE_DISPLAY = /(?:^|;)\s*display\s*:\s*(?:block|flex|grid)\b/i

// An inline element hand-styled to lay out as a block. The preservation
// extensions keep that style verbatim, so it renders as a block everywhere.
export function hasBlockLikeDisplay(node) {
  return (
    node?.nodeType === window.Node.ELEMENT_NODE &&
    BLOCK_LIKE_DISPLAY.test(node.getAttribute("style") || "")
  )
}
